import {OPERATOR} from "../../shared/utils/constants/storage";

export const initialUserClaimsState = {
    uid: "",
    email: "",
    companyId: "",
    companyName: "",
    lastName: "",
    firstName: "",
    roles: "",
    typeUser: OPERATOR,
    authorityType: "",
    companyType: "",
    exp: "",
    appMode: "",
    isConsipCustomer: "",
}

export const initialCompaniesState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    loading: false,
    liveloAssistenzaLoading: false,
    searchText: ""
}
